import React from 'react';

const HuntJoinLeaveButton = ({
  isJoined,
  buttonLoading,
  onJoin,
  onLeave,
  joinLabel = 'Join Treasure Hunt',
  leaveLabel = 'Leave Treasure Hunt',
  className = '',
}) => (
  <div className={`d-flex justify-content-center gap-2 ${className}`}>
    {!isJoined ? (
      <button
        className="animated-subscribe-btn btn btn-success"
        onClick={onJoin}
        disabled={buttonLoading}
      >
        {buttonLoading ? 'Joining...' : joinLabel}
      </button>
    ) : (
      <button
        className="btn btn-outline-danger"
        onClick={onLeave}
        disabled={buttonLoading}
      >
        {buttonLoading ? 'Leaving...' : leaveLabel}
      </button>
    )}
  </div>
);

export default HuntJoinLeaveButton;
